import React from 'react';
import ReactDOM from 'react-dom/client';
import ProblemSection from '../components/ProblemSection';

document.addEventListener('turbo:load', () => {
  const rootElement = document.getElementById('problem-section');
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(React.createElement(ProblemSection));
  }
});
